import Vue from 'vue';
import ElementUI from 'element-ui';
//import ElDatePicker from './components/elements/ElDatePicker'
import App from './App.vue';
import router from './router';
import store from './store/store';
import './lib/axios';
import './filters';
import lang from 'element-ui/lib/locale/lang/hu';
import locale from 'element-ui/lib/locale';
import './directives/Can';
import './styles/index.scss';
import LogRocket from 'logrocket';
import './listeners/index';
import VueApexCharts from 'vue-apexcharts'
import Fragment from 'vue-fragment';
import VueHotkey from 'v-hotkey';
import LocalizedNumeric from './components/fields/LocalizedNumeric'
import './lib/messages-wrapper';
import config from './config/env';

Vue.component('apexchart', VueApexCharts);
Vue.component('el-input-localized-numeric', LocalizedNumeric)

if (config('LOGROCKET_ID')) {
    LogRocket.init(config('LOGROCKET_ID'));
}

locale.use(lang);
Vue.use(ElementUI);
Vue.use(Fragment.Plugin);
Vue.use(VueHotkey);

Vue.mixin({
    methods: {
            $config (key) {
            return config(key)
        }
    }
})

//Vue.component("ElDatePicker", ElDatePicker)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
